module.exports = __webpack_public_path__ + "9ba36057f9ad7dbc97e6e81073cecd3b.svg";